import styles from './index.module.sass';
import Button from 'components/button';
import { config } from 'config';

const Expired = () => {
  return (
    <div className={styles.expired}>
      <h2>連線逾時</h2>
      <p>連線已逾時，請返回 LINE Bank 重新進入服務頁面。</p>
      <Button style={{ minWidth: '100px' }} onClick={() => (window.location.href = config.linebankMainPage)}>
        確認
      </Button>
    </div>
  );
};

export default Expired;
